/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Cancellation_Scheduled_TitleInputs */



/**
* | output |
* | --- |
* | "Cancellation scheduled" |
*
* @param {Gateway_Sub_Cancellation_Scheduled_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_cancellation_scheduled_title = /** @type {((inputs?: Gateway_Sub_Cancellation_Scheduled_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Cancellation_Scheduled_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kündigung geplant")
	return /** @type {LocalizedString} */ ("Cancellation scheduled")
});